module.exports = __webpack_public_path__ + "img/addSubScriptWhite.992590e1.svg";